module.exports = __webpack_public_path__ + "static/carousel-3-e3296f3c8d2c59f75f47da70eb5c7307.jpg";